import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from 'react-router'
import { ModalHost } from '@/components/ui/modal'
import { ThemeProvider } from '@/components/layout/ThemeProvider'
import { Toaster } from '@/components/ui/toaster'
import { TooltipProvider } from '@/components/ui/tooltip'
import { AdminRealtime } from '@/features/admin/realtime'
import { AuthRealtime } from '@/features/auth/realtime'
import { CrmRealtime } from '@/features/crm/realtime'
import { DemosRealtime } from '@/features/demos/realtime'
import { FinanceRealtime } from '@/features/finance/realtime'
import { MailRealtime } from '@/features/mail/realtime'
import { HrRealtime } from '@/features/hr/realtime'
import { NotificationsProvider } from '@/features/notifications/NotificationsProvider'
import { ProjectsRealtime } from '@/features/projects/realtime'
import { RenewalsRealtime } from '@/features/renewals/realtime'
import { isApiError } from '@/lib/api/errors'
import { AuthProvider } from '@/lib/auth/AuthProvider'
import { RealtimeRoot } from '@/lib/ws/RealtimeRoot'
import { router } from './router'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: (n, e) => n < 2 && !(isApiError(e) && e.status >= 400 && e.status < 500),
    },
  },
})

export function App() {
  return (
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <RealtimeRoot>
          <AuthRealtime />
          <FinanceRealtime />
          <ProjectsRealtime />
          <MailRealtime />
          <AdminRealtime />
          <DemosRealtime />
          <RenewalsRealtime />
          <CrmRealtime />
          <HrRealtime />
          <NotificationsProvider>
            <TooltipProvider>
              <RouterProvider router={router} />
              <ModalHost />
              <Toaster />
            </TooltipProvider>
          </NotificationsProvider>
          </RealtimeRoot>
        </AuthProvider>
      </QueryClientProvider>
    </ThemeProvider>
  )
}
